export default __webpack_public_path__ + "locales/sl/Webhooks.json?hash=379bf2e787e1cb3787ac101be5786006";